<div class="app-banner">
    <h2>{{title || '行业全周期收款解决方案'}}</h2>
    <p>{{content || '提升行业经营效率, 引领行业数据化转型'}}</p>
    <img src="/assets/banner_n.png" alt="banner">
</div>